import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=7d0353a4&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=ts"
export * from "./Captcha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0353a4",
  null
  
)

export default component.exports